import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { trigger, style, animate, transition, state } from '@angular/animations';
//Models
import { User } from '../../../shared/models/user.model'
//Mockups
//import { ROLES } from '../../../shared/mockups/roles.mockup';
//import { ESTADOS } from '../../../shared/mockups/estados.mockup';
//Servicios
import { UserService } from '../../../shared/_services/user.service';
import { UtilitiesService } from '../../../shared/_services/utilities.service';
import { UserStates } from '../../../shared/models/userstate.model';
import { UserRoles } from '../../../shared/models/roles.model';
import { Alert } from 'selenium-webdriver';
import { OfficeService } from '../../../shared/_services/office.service';
import { Office } from '../../../shared/models/missingdata.model';


@Component({
  selector: 'app-detail-user',
  templateUrl: './detail-user.component.html',
  styleUrls: ['./detail-user.component.css'],
  animations: [
    trigger('EnterLeave', [
      state('flyin', style({
        opacity: 1,
        transform: 'translateX(0%)'       
      })),
      transition(':enter', [
        style({
          opacity: 0.2,
          transform: 'translateX(-100%)'         
        }),
        animate('0.3s 300ms ease-in')
      ]),
      transition(':leave', [
        animate('0.5s ease-out', style({
          transform: 'translateX(100%)'         
        }))
      ])
    ])
  ]
})

export class DetailUserComponent implements OnInit {

  isEditable: boolean;
  error: any;
  success: any;
  errorestado: any;
  successestado: any;

  showOffices: boolean = false;

  detailForm: FormGroup;

  officesList: Office[];
  SelectRoles : UserRoles[] = [];
  SelectEstados: UserStates[] = [];

  UsuarioSeleccionado: User;

  constructor(
    private modalService: NgbModal,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private officeService: OfficeService,
    private _userService: UserService,
    private _ultilitesService: UtilitiesService,
  ) {
    // Inicializa variables
    this.UsuarioSeleccionado = new User;
    // Obtine id usuario del padre
    this.route.params.subscribe(params => {
      this.isEditable = params['isEditable'] == '0' ? false : true;
      //Carga lista de usuarios   
      this._userService.getById(params['id'])
        .subscribe(
          data => {
            this.UsuarioSeleccionado = data;
          }
        );
    });

  }

  get f() { return this.detailForm.controls; }

  ngOnInit() { 
    //Carga la lista de Estados de Usuario
    this.SelectEstados = this._ultilitesService.currentListUserstates;

    //Carga la lista de Roles
    this.SelectRoles = this._ultilitesService.currentListUserRoles;

    //Carga validaciones de formulario
    this.detailForm = this.formBuilder.group({
      userName: ['', Validators.required],
      userEmail: ['', Validators.required],
      userRole: ['', Validators.required],
      userOffice: [''],
      agentkey: ['']
    });

    // obtener lista de sucursales
    this.officeService.getOffices()
      .subscribe(offices => this.officesList = offices);
    

    this.f.userRole.valueChanges
      .subscribe(res => {
        //this.UsuarioSeleccionado.fkIdOffice = undefined;
        //this.UsuarioSeleccionado.fkAgentKey = undefined;
        if (this.f.userRole.dirty && this.f.userRole.value == 5) {
          this.showOffices = true;
        } else {
          this.officesList = null;
          this.showOffices = false;
        }
      });
  }

  collapse() {
    this.isEditable = false;
  }

  toggleEdit() {
    this.isEditable = !this.isEditable;
  }
  //onEdit(usuario: User): void {
  //  this.UsuarioSeleccionado = usuario;
  //  this.isEditable = true;
  //}

  //onSelect(usuario: User): void {
  //  this.UsuarioSeleccionado = usuario;
  //  this.isEditable = false;

  //}

  comprobarGuardar() {
    //Alert
    //const modalRef = this.modalService.open(AlertComponent, { centered: true });
    //modalRef.componentInstance.title = "Error";
    //modalRef.componentInstance.mensaje = "Algo ha salido mal.";
    this._userService.updateUser(this.UsuarioSeleccionado)
      .subscribe((result: User) => {
        this.error = undefined;
        this.success = "Datos Actualizados";
        this.UsuarioSeleccionado = result;
      }, error => {
        this.success = undefined;
        this.error = error;
        this.cleanError();
      })   
  }

  cleanError() {
    setTimeout(() => {
      this.error = "";
    }, 7000);
  }

  guardarCambios(){
    this.modalService.dismissAll();
    console.log("SE GUARDARON LOS CAMBIOS")
  }

  newPassword(event:any) {      
    this._userService.setNewPassword(event.target.newPassword.value, this.UsuarioSeleccionado, true)
      .subscribe(result => {
        this.errorestado = undefined;
        this.successestado = "Contraseña cambiada satisfactoriamente"
      }, error => {
        this.successestado = undefined;
        this.errorestado = error;
      })    
  }

  setState(event: any) {
    this._userService.setStateUser(event.target.estado.value, event.target.motivo.value, this.UsuarioSeleccionado)
      .subscribe((result: User) => {
        this.errorestado = undefined;
        this.successestado = "Estado cambiado satisfactoriamente";
        this.UsuarioSeleccionado = result;
      }, error => {
        this.successestado = undefined;
        this.errorestado = error;
      });
  }

}

